"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockLocationsClient = void 0;
var __1 = require("..");
var Menu_1 = require("../models/Menu");
var Product_1 = require("../models/Product");
exports.MockLocationsClient = {
    getLocation: function (_locationId) {
        if (_locationId === mockLocation.locationId) {
            return new Promise(function (resolve) { return resolve(mockLocation); });
        }
        return new Promise(function (_resolve, reject) { return reject(404); });
    },
    getLocations: function () { return new Promise(function (resolve) { return resolve([mockLocation]); }); },
    getMenuItem: function (_locationId, menuId, itemId) { return new Promise(function (resolve) { return resolve(mockLocation.menus[menuId].items[itemId]); }); },
    createMenuItem: function (_locationId, _menu, item) {
        var _a, _b;
        var newItem = new Menu_1.MenuItem({ itemId: "fsdfsd", productId: (_a = item.productId) !== null && _a !== void 0 ? _a : "", section: (_b = item.section) !== null && _b !== void 0 ? _b : "", product: mockLocation.products[1] });
        console.log("New Item: " + JSON.stringify(newItem));
        return new Promise(function (resolve) { return resolve(newItem); });
    },
    updateMenuItem: function (_locationId, menuId, itemId, item) {
        var _a, _b;
        var updatedItem = new Menu_1.MenuItem(mockLocation.menus[menuId].items[itemId]);
        updatedItem.productId = (_a = item.productId) !== null && _a !== void 0 ? _a : updatedItem.productId;
        updatedItem.section = (_b = item.section) !== null && _b !== void 0 ? _b : updatedItem.section;
        console.log("Updated Item: " + JSON.stringify(updatedItem));
        return new Promise(function (resolve) { return resolve(updatedItem); });
    },
    deleteMenuItem: function (_locationId, _menuId, _itemId) { return new Promise(function (resolve) { return resolve(); }); },
    getMenu: function (_locationId, menuId) { return new Promise(function (resolve) { return resolve(mockLocation.menus[menuId]); }); },
    getMenus: function (_locationId) { return new Promise(function (resolve) { return resolve(mockLocation.menus); }); },
    createMenu: function (_locationId, menu) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var newMenu = new Menu_1.Menu({ id: "fg4gfdfg", name: (_a = menu.name) !== null && _a !== void 0 ? _a : "", areaIds: (_b = menu.areaIds) !== null && _b !== void 0 ? _b : [], active: (_c = menu.active) !== null && _c !== void 0 ? _c : false, activePeriods: (_d = menu.activePeriods) !== null && _d !== void 0 ? _d : {}, sections: (_e = menu.sections) !== null && _e !== void 0 ? _e : [], config: (_f = menu.config) !== null && _f !== void 0 ? _f : {}, items: {}, menuType: (_g = menu.menuType) !== null && _g !== void 0 ? _g : "preorder", description: (_h = menu.description) !== null && _h !== void 0 ? _h : "", eventDetails: (_j = menu.eventDetails) !== null && _j !== void 0 ? _j : {} });
        console.log("New Menu: " + JSON.stringify(newMenu));
        return new Promise(function (resolve) { return resolve(newMenu); });
    },
    updateMenu: function (_locationId, menuId, menu) {
        var _a, _b, _c, _d, _e;
        var updatedMenu = new Menu_1.Menu(mockLocation.menus[menuId]);
        updatedMenu.name = (_a = menu.name) !== null && _a !== void 0 ? _a : updatedMenu.name;
        updatedMenu.active = (_b = menu.active) !== null && _b !== void 0 ? _b : updatedMenu.active;
        updatedMenu.activePeriods = (_c = menu.activePeriods) !== null && _c !== void 0 ? _c : updatedMenu.activePeriods;
        updatedMenu.sections = (_d = menu.sections) !== null && _d !== void 0 ? _d : updatedMenu.sections;
        updatedMenu.config = (_e = menu.config) !== null && _e !== void 0 ? _e : updatedMenu.config;
        console.log("Updated menu: " + JSON.stringify(updatedMenu));
        return new Promise(function (resolve) { return resolve(updatedMenu); });
    },
    deleteMenu: function (_locationId, _menuId) { return new Promise(function (resolve) { return resolve(); }); },
    getProduct: function (_locationId, productId) { return new Promise(function (resolve) { return resolve(mockLocation.products[productId]); }); },
    getProducts: function (_locationId) { return new Promise(function (resolve) { return resolve(mockLocation.products); }); },
    createProduct: function (_locationId, product) {
        var _a, _b, _c, _d, _e, _f;
        var newProduct = new Product_1.Product({ id: "fg4gfdfg", description: (_a = product.description) !== null && _a !== void 0 ? _a : "", name: (_b = product.name) !== null && _b !== void 0 ? _b : "", available: (_c = product.available) !== null && _c !== void 0 ? _c : false, category: (_d = product.category) !== null && _d !== void 0 ? _d : new Product_1.Category({ kitchenCategory: "", displayCategory: "", tags: [] }), sizes: (_e = product.sizes) !== null && _e !== void 0 ? _e : [new Product_1.Size({ name: "medium", price: 0 })], vatPercent: (_f = product.vatPercent) !== null && _f !== void 0 ? _f : 20 });
        console.log("New product: " + JSON.stringify(newProduct));
        return new Promise(function (resolve) { return resolve(newProduct); });
    },
    updateProduct: function (_locationId, productId, product) {
        var _a, _b, _c, _d, _e;
        var updatedProduct = new Product_1.Product(mockLocation.products[productId]);
        updatedProduct.name = (_a = product.name) !== null && _a !== void 0 ? _a : updatedProduct.name;
        updatedProduct.available = (_b = product.available) !== null && _b !== void 0 ? _b : updatedProduct.available;
        updatedProduct.category = (_c = product.category) !== null && _c !== void 0 ? _c : updatedProduct.category;
        updatedProduct.description = (_d = product.description) !== null && _d !== void 0 ? _d : updatedProduct.description;
        updatedProduct.sizes = (_e = product.sizes) !== null && _e !== void 0 ? _e : updatedProduct.sizes;
        console.log("Updated Item: " + JSON.stringify(updatedProduct));
        return new Promise(function (resolve) { return resolve(updatedProduct); });
    },
    deleteProduct: function (_locationId, _productId) { return new Promise(function (resolve) { return resolve({ success: true }); }); },
    getArea: function (_locationId, areaId) { return new Promise(function (resolve) { return resolve(mockLocation.areas[areaId]); }); },
    getAreas: function (_locationId) { return new Promise(function (resolve) { return resolve(mockLocation.areas); }); },
    createArea: function (_locationId, area) {
        var newArea = new __1.Area({ id: "ewfeoaplmd", name: area.name, backgroundColour: area.backgroundColour, textColour: area.textColour });
        console.log("New area: " + JSON.stringify(newArea));
        return new Promise(function (resolve) { return resolve(newArea); });
    },
    deleteArea: function (_locationId, _areaId) { return new Promise(function (resolve) { return resolve(); }); },
    getInvoiceUrl: function (_locationId, _invoiceId, _authToken) { return new Promise(function (resolve) { return resolve("http://example.com"); }); },
    createAssetUrl: function (_locationId, _asset, _authToken) { return new Promise(function (resolve) { return resolve({ uploadUrl: "https://servd-web-assets-dan.s3.eu-west-2.amazonaws.com/123_dsdfasgfdgdsfgd_hero?bloody-long-url-follows-here", key: "123_dsdfasgfdgdsfgd_hero" }); }); }
};
var mockLocation = {
    "locationId": "123",
    "name": "Premier Inn, Ipswich",
    "branchName": "Norwich Road",
    "config": {},
    "vatConfig": {
        "vatNumber": "1234567890",
        "address": "10 Downing Street, London",
        "prefix": "MOCK99",
        "idSequence": 7,
        "sendInvoices": true,
    },
    "menus": {
        "0fsifxvf": {
            "name": "default",
            "active": true,
            "areaIds": ["e01438ca-9b22-461a-bef0-ed938549859f"],
            "activePeriods": {},
            "config": {},
            "id": "0fsifxvf",
            "items": {
                "LLsig8e": {
                    "productId": "11",
                    "itemId": "LLsig8e",
                    "section": "Drinks",
                    "product": {
                        "name": "Caffe latte",
                        "available": true,
                        "description": "",
                        "id": "11",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "small",
                                "price": 200
                            },
                            {
                                "name": "medium",
                                "price": 330
                            },
                            {
                                "name": "large",
                                "price": 450
                            }
                        ],
                        "category": {
                            "kitchenCategory": "drinks",
                            "displayCategory": "drinks",
                            "tags": []
                        }
                    }
                },
                "ggr3mg4o3lrgvv4nnnv": {
                    "productId": "12",
                    "itemId": "ggr3mg4o3lrgvv4nnnv",
                    "section": "Drinks",
                    "product": {
                        "name": "Cappuccino",
                        "available": true,
                        "description": "",
                        "id": "12",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 330
                            }
                        ],
                        "category": {
                            "kitchenCategory": "drinks",
                            "displayCategory": "drinks",
                            "tags": []
                        }
                    }
                },
                "w6w94lqf3abkrpihqje": {
                    "productId": "7",
                    "itemId": "w6w94lqf3abkrpihqje",
                    "section": "Mains",
                    "product": {
                        "name": "Sweet potato and chickpea curry",
                        "available": true,
                        "description": "Served with basmati rice",
                        "vatPercent": 20,
                        "id": "7",
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 1200
                            }
                        ],
                        "category": {
                            "kitchenCategory": "mains",
                            "displayCategory": "mains",
                            "tags": []
                        }
                    }
                },
                "sajdh928h3uf03g0rlkn0a": {
                    "productId": "10",
                    "itemId": "sajdh928h3uf03g0rlkn0a",
                    "section": "Desserts",
                    "product": {
                        "name": "Apple and blackberry crumble",
                        "available": true,
                        "description": "Served with custard",
                        "id": "10",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 450
                            }
                        ],
                        "category": {
                            "kitchenCategory": "desserts",
                            "displayCategory": "desserts",
                            "tags": [
                                "hot"
                            ]
                        }
                    }
                },
                "dsf98794fc03ciams0dv95": {
                    "productId": "9",
                    "itemId": "dsf98794fc03ciams0dv95",
                    "section": "Desserts",
                    "product": {
                        "name": "Ice cream",
                        "available": true,
                        "description": "Assorted flavours",
                        "id": "9",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 450
                            }
                        ],
                        "category": {
                            "kitchenCategory": "desserts",
                            "displayCategory": "desserts",
                            "tags": [
                                "cold"
                            ]
                        }
                    }
                },
                "iofdS34": {
                    "productId": "174scqnmy8ckqm1me7w",
                    "itemId": "iofdS34",
                    "section": "Mains",
                    "product": {
                        "name": "Thai green chicken curry",
                        "available": true,
                        "description": "Served with basmati rice",
                        "id": "174scqnmy8ckqm1me7w",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 1400
                            }
                        ],
                        "category": {
                            "kitchenCategory": "mains",
                            "displayCategory": "mains",
                            "tags": []
                        }
                    }
                },
                "gv44jxx": {
                    "productId": "2",
                    "itemId": "gv44jxx",
                    "section": "Starters",
                    "product": {
                        "name": "Buttermilk crispy chicken wings",
                        "available": true,
                        "description": "Buttermilk ranch dressing",
                        "id": "2",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 650
                            },
                            {
                                "name": "small",
                                "price": 800
                            }
                        ],
                        "category": {
                            "kitchenCategory": "starters",
                            "displayCategory": "starters",
                            "tags": []
                        }
                    }
                },
                "fT733Ect": {
                    "productId": "5",
                    "itemId": "fT733Ect",
                    "section": "Mains",
                    "product": {
                        "name": "Panini of the day",
                        "available": true,
                        "description": "Ask your server for today\"s filling",
                        "id": "5",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 750
                            }
                        ],
                        "category": {
                            "kitchenCategory": "starters",
                            "displayCategory": "starters",
                            "tags": []
                        }
                    }
                },
                "AAl3r8fs": {
                    "productId": "6",
                    "itemId": "AAl3r8fs",
                    "section": "Mains",
                    "product": {
                        "name": "Penang chicken curry",
                        "available": true,
                        "description": "Served with basmati rice and naan bread",
                        "id": "6",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 1200
                            }
                        ],
                        "category": {
                            "kitchenCategory": "mains",
                            "displayCategory": "mains",
                            "tags": []
                        }
                    }
                },
                "ty5zzg4": {
                    "productId": "1",
                    "itemId": "ty5zzg4",
                    "section": "Starters",
                    "product": {
                        "name": "Soup of the day",
                        "available": true,
                        "description": "Served with rustic baguette",
                        "id": "1",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "Small",
                                "price": 300
                            },
                            {
                                "name": "Large",
                                "price": 500
                            }
                        ],
                        "category": {
                            "kitchenCategory": "starters",
                            "displayCategory": "starters",
                            "tags": []
                        }
                    }
                },
                "dve93kf": {
                    "productId": "4",
                    "itemId": "dve93kf",
                    "section": "Starters",
                    "product": {
                        "name": "Mozzarella dippers",
                        "available": true,
                        "description": "Breaded mozzarella dippers with a BBQ dip",
                        "id": "4",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "medium",
                                "price": 500
                            }
                        ],
                        "category": {
                            "kitchenCategory": "starters",
                            "displayCategory": "starters",
                            "tags": []
                        }
                    }
                },
                "g30gsdv": {
                    "productId": "3",
                    "itemId": "g30gsdv",
                    "section": "Starters",
                    "product": {
                        "name": "Japanese style bubble coated prawns",
                        "available": true,
                        "description": "Green chilli & lime dip",
                        "id": "3",
                        "vatPercent": 20,
                        "sizes": [
                            {
                                "name": "Medium",
                                "price": 700
                            },
                            {
                                "name": "massive",
                                "price": 566
                            }
                        ],
                        "category": {
                            "kitchenCategory": "starters",
                            "displayCategory": "starters",
                            "tags": []
                        }
                    }
                }
            },
            "sections": [
                {
                    "title": "Drinks",
                    "categories": ["drinks"],
                    "sections": [
                        {
                            "title": "Hot",
                            "categories": ["hot"],
                            "sections": []
                        },
                    ]
                },
                {
                    "title": "Starters",
                    "categories": ["starters"],
                    "sections": []
                },
                {
                    "title": "Mains",
                    "categories": ["mains"],
                    "sections": []
                },
                {
                    "title": "Desserts",
                    "categories": ["desserts"],
                    "sections": []
                }
            ],
            "menuType": "preorder",
            "description": "A menu",
            "eventDetails": {}
        }
    },
    "products": {
        "1": {
            "id": "1",
            "name": "Soup of the day",
            "description": "Served with rustic baguette",
            "sizes": [{ "name": "medium", "price": 500 }],
            "category": {
                "displayCategory": "starters",
                "kitchenCategory": "starters",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "2": {
            "id": "2",
            "name": "Buttermilk crispy chicken wings",
            "description": "Buttermilk ranch dressing",
            "sizes": [{ "name": "medium", "price": 650 }],
            "category": {
                "displayCategory": "starters",
                "kitchenCategory": "starters",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "3": {
            "id": "3",
            "name": "Japanese style bubble coated prawns",
            "description": "Green chilli & lime dip",
            "sizes": [{ "name": "medium", "price": 700 }],
            "category": {
                "displayCategory": "starters",
                "kitchenCategory": "starters",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "4": {
            "id": "4",
            "name": "Mozzarella dippers",
            "description": "Breaded mozzarella dippers with a BBQ dip",
            "sizes": [{ "name": "medium", "price": 500 }],
            "category": {
                "displayCategory": "starters",
                "kitchenCategory": "starters",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "5": {
            "id": "5",
            "name": "Panini of the day",
            "description": "Ask your server for today\"s filling",
            "sizes": [{ "name": "medium", "price": 750 }],
            "category": {
                "displayCategory": "starters",
                "kitchenCategory": "starters",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "6": {
            "id": "6",
            "name": "Penang chicken curry",
            "description": "Served with basmati rice and naan bread",
            "sizes": [{ "name": "medium", "price": 1200 }],
            "category": {
                "displayCategory": "mains",
                "kitchenCategory": "mains",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "7": {
            "id": "7",
            "name": "Sweet potato and chickpea curry",
            "description": "Served with basmati rice",
            "sizes": [{ "name": "medium", "price": 1200 }],
            "category": {
                "displayCategory": "mains",
                "kitchenCategory": "mains",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "8": {
            "id": "8",
            "name": "Thai green chicken curry",
            "description": "Served with basmati rice",
            "sizes": [{ "name": "medium", "price": 1200 }],
            "category": {
                "displayCategory": "mains",
                "kitchenCategory": "mains",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "9": {
            "id": "9",
            "name": "Ice cream",
            "description": "Assorted flavours",
            "sizes": [{ "name": "medium", "price": 450 }],
            "category": {
                "displayCategory": "desserts",
                "kitchenCategory": "desserts",
                "tags": ["cold"]
            },
            "available": true,
            "vatPercent": 20,
        },
        "10": {
            "id": "10",
            "name": "Apple and blackberry crumble",
            "description": "Served with custard",
            "sizes": [{ "name": "medium", "price": 450 }],
            "category": {
                "displayCategory": "desserts",
                "kitchenCategory": "desserts",
                "tags": ["hot"]
            },
            "available": true,
            "vatPercent": 20,
        },
        "11": {
            "id": "11",
            "name": "Caffe latte",
            "description": "",
            "sizes": [
                { "name": "small", "price": 200 },
                { "name": "medium", "price": 330 },
                { "name": "large", "price": 450 }
            ],
            "category": {
                "displayCategory": "drinks",
                "kitchenCategory": "drinks",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
        "12": {
            "id": "12",
            "name": "Cappuccino",
            "description": "",
            "sizes": [{ "name": "medium", "price": 330 }],
            "category": {
                "displayCategory": "drinks",
                "kitchenCategory": "drinks",
                "tags": []
            },
            "available": true,
            "vatPercent": 20,
        },
    },
    "zones": [
        "kitchen",
        "bar"
    ],
    "areas": {
        "e01438ca-9b22-461a-bef0-ed938549859f": {
            "id": "e01438ca-9b22-461a-bef0-ed938549859f",
            "name": "restaurant",
            "backgroundColour": "#FFF",
            "textColour": "#d4bebe"
        }
    }
};
